module.exports = __webpack_public_path__ + "static/2021_into_2022-3962485961345f5aa84c5f9a2ba84540.png";